import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, cloneDeep } from 'lodash';
import { round } from 'mathjs';

import '../scss/index.scss';
import '../../scss/table.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import PDF from '../../../component/pdf';
import Title from '../../../component/title';
import HeadPdf from '../../../component/head-pdf';
import FootPdf from '../../../component/foot-pdf';
import moIndex from '../../../store/index';
import moSalaryYear from './store';
import Empty from '@comp/empty/index';
import moUser from '@store/user';
import Chart from './chart';
import Table from './table';

interface IProps {}
interface IState {}

const SalaryIndustryPDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const {
    xData, yData, labels,
    tableHead, tableLeft, tableRight,
  } = moSalaryYear;
  const { isMock } = moIndex;
  const descArr = [
    '统计说明：在相同行业、城市组合下，计算各职能月度薪酬的中位数，然后计算月度薪酬的同比变化率，最后计算各统计周期下的变化率均值，即为涨薪率',
    '基于以下指标的涨幅：CPI，行业上市公司的营收、利润和薪酬成本，行业的招聘量和薪酬，生成算法模型。以近半年的数据为输入数据，使用该模型预测下一期的涨薪率。每个季度对涨薪率进行一次预测，上半年预测当年的涨薪率、下半年预测次年的涨薪率。',
    '*此处为不区分城市的涨薪率',
  ];

  // 第二个参数 - 保留几位小数
  const clacRate = (value: any, digit: number = 1) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(value)) return '-';
    if (value === null || value === '' || value === undefined) return '-';
    if (value === 0) return 0;
    return round(value * 100, digit);
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <PDF>
      <section className="salary-up-pdf_1010">
        <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
        <section className="content-salary-1001">
          <section className="title-1001">
            <Title title="涨薪率 - 按时间" bigTitle="人力指标" tag={industry.name} />
          </section>

          <section className="salary-up_1010">
            <p className="one-13 one-166" style={{ color: '#878787' }}>
              {descArr.map((text: any, ix: number) => (
                <span key={ix}>{text}</span>
              ))}
            </p>
            {!isEmpty(xData) ? (
              <section className="salary-up-box-1100">
                <section className={[
                  'box-13', !isMock ? '' : 'mock-100',
                ].join(' ')}
                style={{ overflowY: 'auto' }}>
                  <section className="chart-title_03">
                    {labels.map((item: any, idx: number) => (
                      <p key={idx} className="line-03"
                        style={{ marginRight: 0, marginTop: '10px' }}>
                        <strong>{newRate(item?.change_rate)}</strong>
                        <span>{item?.date}{item?.industry_lv1}涨薪率</span>
                      </p>
                    ))}
                  </section>
                  <section>
                    <Chart height={300} xData={xData.slice(0, 5)} yData={yData} />
                  </section>
                </section>
              </section>
            ) : (<Empty padding="50px 0" />)}
          </section>

          {xData.length > 0 ? <Table /> : null}
        </section>
        <FootPdf />
      </section>
    </PDF>
  );
};

export default observer(SalaryIndustryPDF);
